import styled from 'styled-components';
import { ReactComponent as Info } from '@/assets/images/medicine/info.svg';

export const MEDICINE_NOTICE_BANNER_HEIGHT = 56;

const MedicineNoticeBanner = () => {
  return (
    <Wrapper>
      <Info />
      <NoticeText>
        여러 약품 정보를 자세히 등록할수록
        <span> 환자가 약국을 선택할 가능성이 높아져요.</span>
      </NoticeText>
    </Wrapper>
  );
};

export default MedicineNoticeBanner;

const Wrapper = styled.div`
  position: absolute;
  top: -32px;
  left: -32px;
  width: 100vw;
  padding: 16px;
  height: ${MEDICINE_NOTICE_BANNER_HEIGHT}px;
  display: flex;
  align-items: center;

  svg {
    margin-right: 12px;
    min-width: 24px;
  }
  ${({ theme }) => `
    background: ${theme.DF_COLOR.BLUE100};
  `};
`;

const NoticeText = styled.div`
  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI17SB};
    color: ${theme.DF_COLOR.GRAY800};

    span {
      color: ${theme.DF_COLOR.BLUE600};
    }
  `};
`;
